import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginService } from '../services/login.service';
import { environment } from '../../environments/environment';

import {
  RouterOutlet,
  RouterLink,
  RouterLinkActive,
  Router,
} from '@angular/router';
import {
  FormBuilder,
  FormControl, 
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { NotificationService } from '../services/notification.service';
import { ISpinnerManager } from '../interface-spinner';

import { AbstractComponent } from '../abstract-component';
import { MetaMaskService } from '../services/metamask-service' ;
import { ValidatorNamePipe } from '../pipes/validator-name.pipe';


@Component({
    selector: 'app-header',
    imports: [
        CommonModule,
        RouterOutlet,
        RouterLink,
        RouterLinkActive,
        ReactiveFormsModule,
        MatProgressSpinnerModule,
        ValidatorNamePipe,
    ],
    templateUrl: './header.component.html',
    providers: [MetaMaskService],
    styleUrl: './header.component.css'
})
export class HeaderComponent
  extends AbstractComponent
  implements ISpinnerManager, OnInit
{
  eth_requestAccounts() {
    this.metaMaskService.eth_requestAccounts();
  }
  loginService = inject(LoginService);

  metaMaskService = inject(MetaMaskService);
  router: Router = inject(Router);
  environment = environment;
  spinnerActive = false;

  searchForm = new FormGroup({
    search: new FormControl(''),
  });
  search = new FormControl('');
  _notificationService: NotificationService;
  username: String = "";
  isLogIn : boolean = false;

  constructor(notificationService: NotificationService) {
    super();
    this._notificationService = notificationService;
    this._notificationService.manager = this;
  }

  ngOnInit() {
    //this.isLogIn = this.keyCloakService.isLoggedIn();
 
  }
  

  getSpinnerStatus(): boolean {
    return this.spinnerActive;
  }
  setSpinnerStatus(value: boolean): void {
    this.spinnerActive = value;
  }
  onLogout() {
    let url = window.location.origin + `/block-explorer/bloques`;

  }
  searchBlockTransaction() {
    let hash = this.searchForm.controls['search'].value;
    console.log(`Search ${hash}`);

  }
}
